export enum FIELD_NAMES {
    RoleName = "roleName",
    Company = "company",
    Description = "description",
    PermissionPreset = "permissionPreset",
    Permissions = "permissions"
}
